import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDropDownBoxModule, DxListModule, DxPopoverModule, DxTreeViewComponent, DxTreeViewModule } from 'devextreme-angular';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CtGenLookupCokluService } from './ct-gen-lookup-coklu.service';
import { LabelMode } from 'devextreme/common';

@Component({
  selector: 'dk-ct-gen-lookup-coklu',
  standalone: true,
  imports: [CommonModule,DxTreeViewModule,DxDropDownBoxModule,DxPopoverModule,DxListModule],
  templateUrl: './ct-gen-lookup-coklu.component.html',
  styleUrls: ['./ct-gen-lookup-coklu.component.scss'],
})
export class CtGenLookupCokluComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild(DxTreeViewComponent, { static: false }) treeView:any;
  @Input() public entityName: string;
  @Input() public labelText: string;
  @Input() public valueExpr = "Kod";
  @Input() public displayExpr = "Ad";
  @Input() public filterColumn: string;
  @Input() public filterName: any;
  @Input() public filterSymbol: string;
  @Input() public labelMode:LabelMode;
  @Input() public showValuesPopoverOnHover:boolean = true;
  @Output() private dataResult = new EventEmitter<string>();
  treeDataSource: any;

  treeBoxValue: string[];
  treeBoxDisplayValue: string[];

  isPopoverVisible:boolean = false;
  isDropDownBoxOpened:boolean = false;

  genLookupElement:any;

  private handleMouseOver = (e: any) => {
    this.isPopoverVisible = true;
  };

  private handleMouseOut = (e: any) => {
    this.isPopoverVisible = false;
  };

  constructor(http: HttpClient, private ctGenLookupCokluService: CtGenLookupCokluService) {
  }



  ngOnInit(): void {
    this.treeDataSource = this.ctGenLookupCokluService.getDataSource(this.entityName,this.filterColumn,this.filterName,this.filterSymbol);

    this.genLookupElement = document.querySelector('.gen-coklu-lookup');
    if(this.genLookupElement){
      this.genLookupElement.addEventListener('mouseover', this.handleMouseOver);
      this.genLookupElement.addEventListener('mouseout', this.handleMouseOut);
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['filterName']){
      this.treeDataSource = this.ctGenLookupCokluService.getDataSource(this.entityName,this.filterColumn,this.filterName,this.filterSymbol);
    }
  }

  ngOnDestroy(){
    if(this.genLookupElement){
      this.genLookupElement.removeEventListener('mouseover', this.handleMouseOver);
      this.genLookupElement.removeEventListener('mouseout', this.handleMouseOut);
    }
  }

  onTreeViewReady(e:any) {
    this.updateSelection(e.component);
  }

  onDropDownBoxValueChanged(e:any) {
    this.updateSelection(this.treeView && this.treeView.instance);
    const result = this.treeBoxValue?.join(',') ? this.treeBoxValue?.join(',') : null;
    this.dataResult.emit(result)
  }

  onTreeViewSelectionChanged(e:any) {
    this.treeBoxValue = e.component.getSelectedNodeKeys();
    this.treeBoxDisplayValue = e.component.getSelectedNodes().map((node:any) => node.itemData[this.displayExpr]);
  }

  updateSelection(treeView:any) {
    if (!treeView) return;

    if (!this.treeBoxValue) {
      treeView.unselectAll();
    }

    if (this.treeBoxValue) {
      this.treeBoxValue.forEach(((value) => {
        treeView.selectItem(value);
      }));
    }
  }

}
